module.exports = __webpack_public_path__ + "img/p3.6aed6c04.png";